// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "::v-deep :not(.v-icon_6whxi){font-family:\"proxima-nova\",\"OpenSans\",\"Pridi\",\"NotoSans\",\"NotoSansSC\",\"NotoSansHebrew\",\"NotoSansJapanese\",\"Hiragino Kaku Gothic Pro\",\"Yu Gothic Medium\",\"Yu Gothic\",Meiryo,\"source-han-sans-japanese\",\"source-han-sans-korean\",\"source-han-sans-simplified-c\",Helvetica,Arial,sans-serif}.nsAddressForm_2PpKH .dualColumn_36NPD{display:flex;align-content:space-between}.nsAddressForm_2PpKH .dualColumn_36NPD .firstCol_KNxva{margin-right:20px}.optional_3T-iD{color:#bbbcbc}", ""]);
// Exports
exports.locals = {
	"v-icon": "v-icon_6whxi",
	"nsAddressForm": "nsAddressForm_2PpKH",
	"dualColumn": "dualColumn_36NPD",
	"firstCol": "firstCol_KNxva",
	"optional": "optional_3T-iD"
};
module.exports = exports;
